import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import * as sweetalert from "sweetalert";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
import { useRef } from "react";
import { useCallback } from "react";
import ImagePopup from "./ImagePopup";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;

export const homepage = packageJson.homepage;




export default function Update() {
 

  const navigate = useNavigate();
  const location = useLocation();
  const { id, cityid, zoneid } = useParams();
  const [staff, setStaff] = useState([]);
  const [Staffoption, setStaffoption] = useState([]);
  const [city, setCity] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [city_id, setcity_id] = useState("1");
  const [admin, setAdmin] = useState("");
  const [adminArabic, setAdminArabic] = useState("");
  const [zone, setZone] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [providerSyriatel, setProviderSyriatel] = useState([]);
  const [providerMTN, setProviderMTN] = useState([]);
  const [providerMTN1, setproviderMTN1] = useState("");
  const [providerSyriatel1, setproviderSyriatel1] = useState("");
  const [PersonImage, setPersonImage] = useState([]);
  const [PersonImage1, setPersonImage1] = useState("");
  const [Photo1, setPhoto1] = useState([]);
  const [Photo2, setPhoto2] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage1, setSelectedImage1] = useState("");
  const [selectedImage2, setSelectedImage2] = useState("");
  const [selectedImage22, setSelectedImage22] = useState("");
  const [selectedImage3, setSelectedImage3] = useState("");
  const [selectedImage33, setSelectedImage33] = useState("");
  const [img, setImg] = useState("");
  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");
  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (file.size <= 512 * 1024) { // Check size is within 512 KB
            const objectURL = URL.createObjectURL(file);
            setSelectedImage(objectURL); // Store the URL, not the file
            setSelectedImage1(file); // Store the URL, not the file

            setFormValues((prevState) => ({
                ...prevState,
                personal_photo: {
                    value: file, // Keep the file in form state for submitting the form
                    error: "",
                },
            }));
        } else {
            setFormValues((prevState) => ({
                ...prevState,
                personal_photo: {
                    ...prevState.personal_photo,
                    error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
                },
            }));
        }
    }
};
  const imageChange2 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (file.size <= 512 * 1024) { // Check size is within 512 KB
            const objectURL = URL.createObjectURL(file);
            setSelectedImage2(objectURL); // Store the URL, not the file
            setSelectedImage22(file); // Store the URL, not the file

            setFormValues((prevState) => ({
              ...prevState,
              id_photo1: {
                value: file,
                error: "",
              },
            }));
          } else {
            // If file size is not valid, set an error and do not update the image
            setFormValues((prevState) => ({
              ...prevState,
              id_photo1: {
                ...prevState.id_photo1,
                error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
              },
            }));
          }
    }
};
  const imageChange3 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (file.size <= 512 * 1024) { // Check size is within 512 KB
            const objectURL = URL.createObjectURL(file);
            setSelectedImage3(objectURL); // Store the URL, not the file
            setSelectedImage33(file); // Store the URL, not the file

            setFormValues((prevState) => ({
              ...prevState,
              id_photo2: {
                value: file,
                error: "",
              },
            }));
          } else {
            // If file size is not valid, set an error and do not update the image
            setFormValues((prevState) => ({
              ...prevState,
              id_photo2: {
                ...prevState.id_photo2,
                error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
              },
            }));
          }
    }
};
  // const imageChange = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     // Assuming you only care about the first file in case of multiple files
  //     const file = e.target.files[0];
  //     if (file) {
  //       // Check if file size is less than 512 KB
  //       if (file.size <= 512 * 1024) {
  //         // 512 KB
  //         // If file size is valid, update state to reflect the new image
  //         setSelectedImage(file);
  //         // Clear any error related to file size if there was one
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           personal_photo: {
  //             value: file,
  //             error: "",
  //           },
  //         }));
  //       } else {
  //         // If file size is not valid, set an error and do not update the image
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           personal_photo: {
  //             ...prevState.personal_photo,
  //             error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
  //           },
  //         }));
  //       }
  //     }
  //     setSelectedImage(e.target.files[0]);
  //   }
  // };
  // const imageChange2 = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const file = e.target.files[0];
  //     if (file) {
  //       // Check if file size is less than 512 KB
  //       if (file.size <= 512 * 1024) {
  //         // 512 KB
  //         // If file size is valid, update state to reflect the new image
  //         setSelectedImage2(file);
  //         // Clear any error related to file size if there was one
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           id_photo1: {
  //             value: file,
  //             error: "",
  //           },
  //         }));
  //       } else {
  //         // If file size is not valid, set an error and do not update the image
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           id_photo1: {
  //             ...prevState.id_photo1,
  //             error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
  //           },
  //         }));
  //       }
  //     }
  //     setSelectedImage2(e.target.files[0]);
  //   }
  // };
  // const imageChange3 = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const file = e.target.files[0];
  //     if (file) {
  //       // Check if file size is less than 512 KB
  //       if (file.size <= 512 * 1024) {
  //         // 512 KB
  //         // If file size is valid, update state to reflect the new image
  //         setSelectedImage3(file);
  //         // Clear any error related to file size if there was one
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           id_photo2: {
  //             value: file,
  //             error: "",
  //           },
  //         }));
  //       } else {
  //         // If file size is not valid, set an error and do not update the image
  //         setFormValues((prevState) => ({
  //           ...prevState,
  //           id_photo2: {
  //             ...prevState.id_photo2,
  //             error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
  //           },
  //         }));
  //       }
  //     }
  //     setSelectedImage3(e.target.files[0]);
  //   }
  // };
  const handleImageChange = (event, setImage) => {
    const file = event.target.files[0];  // Get the first file from the file input
    if (file) {
      setSelectedImage(file);  // Assuming setImage will store the file in the state
    } else {
      console.error("No file chosen or file input is empty.");
    }
    }
  

  const [selectedImages, setSelectedImages] = useState({
    personalImage: [],
    frontIdImage: "",
    backIdImage: "",
  });
  const [city_id2, setcity_id2] = useState({
    city_id: {
      value: "",
    },
  });
  const [formValues, setFormValues] = useState({
    first_name: {
      value: "",
      error: "",
    },
    last_name: {
      value: "",
      error: "",
    },
    father_name: {
      value: "",
      error: "",
    },
    mother_name: {
      value: "",
      error: "",
    },
    mobile_number: {
      value: "",
      error: "",
    },
    id_number: {
      value: "",
      error: "",
    },
    address: {
      value: "",
      error: "",
    },
    staff_type: {
      value: "",
      error: "",
    },
    city_id: {
      value: "",
      error: "",
    },
    zone_id: {
      value: "",
      error: "",
    },
    personal_photo: {
      value: "",
      error: "",
    },
    id_photo1: {
      value: "",
      error: "",
    },
    id_photo2: {
      value: "",
      error: "",
    },
    longitude: {
      value: "",
      error: "",
    },
    latitude: {
      value: "",
      error: "",
    },
    active: {
      value: 1,
      error: "",
    },
  });
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/staff/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        // setSelectedImages({
        //   ...selectedImages,
        //   personalImage: res.data.images.personal_photo,
        //   frontIdImage: res.data.images.id_photo1,
        //   backIdImage: res.data.images.id_photo2,
        // });

        setFormValues({
          first_name: {
            value: res.data.first_name,
          },
          last_name: {
            value: res.data.last_name,
          },
          father_name: {
            value: res.data.father_name,
          },
          mother_name: {
            value: res.data.mother_name,
          },
          mobile_number: {
            value: res.data.mobile_number,
          },
          id_number: {
            value: res.data.id_number,
          },
          address: {
            value: res.data.address,
          },
          staff_type: {
            value: res.data.staff_type,
          },
          city_id: {
            value: res.data.city_id.id,
          },
          zone_id: {
            value: res.data.zone_id.id,
          },
          personal_photo: {
            value: res.data.images.personal_photo,
            error: "",
          },
          id_photo1: {
            value: res.data.images.id_photo1,
            error: "",
          },
          id_photo2: {
            value: res.data.images.id_photo2,
            error: "",
          },
          longitude: {
            value: res.data.login_information.longitude,
          },
          latitude: {
            value: res.data.login_information.latitude,
          },
          active: {
            value: 1,
          },
        });
        setImg([res.data.images.personal_photo]);
        setImg1([res.data.images.id_photo1]);
        setImg2([res.data.images.id_photo2]);
        setproviderMTN1(res.data.distributor_id?.id);
        setproviderSyriatel1(res.data.provider_id?.id);
        setAdmin(res.data.staff_type);
        if (res.data.staff_type == "ادمن") {
          setAdminArabic("ادمن");
        }
        if (res.data.staff_type == "موزع عام") {
          setAdminArabic("موزع عام");
        }
        if (res.data.staff_type == "موزع خاص") {
          setAdminArabic("موزع خاص");
        }
        if (res.data.staff_type == "زبون") {
          setAdminArabic("زبون");
        }
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    const config = {
      headers: { "Content-Type": "application/json", Authorization: null },
    };
    axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
      axios
        .get(`${BaseUrl}/api/countries`, {
          withCredentials: true,
        })
        .then((res) => {
          setCountries(res.data.data);

          setcity_id(res.data.data[0].id);
          axios
            .get(`${BaseUrl}/api/country/${city_id}/cities`, {
              withCredentials: true,
            })
            .then((rescities) => {
              setCity(rescities.data.data);
            });
        });
    });
  }, []);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/GetStaffType`, {
        withCredentials: true,
      })
      .then((res) => {
        setStaff(res.data.data);
      });
  }, []);

  useEffect(() => {
    const config = {
      headers: { "Content-Type": "application/json", Authorization: null },
    };
    axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
      axios
        .get(`${BaseUrl}/api/countries`, {
          withCredentials: true,
        })
        .then((res) => {
          setCountries(res.data.data);

          const Id = res.data.data[0].id;

          axios
            .get(`${BaseUrl}/api/country/${Id}/city/${cityid}/zones`, {
              withCredentials: true,
            })
            .then((resZone) => {
              setZone(resZone.data.data);
            });
        });
    });
    axios
      .get(`${BaseUrl}/api/providers`, {
        withCredentials: true,
      })
      .then((res) => {
        setProviderSyriatel(res.data.data);
      });
    axios
      .get(`${BaseUrl}/api/distributors`, {
        withCredentials: true,
      })
      .then((res) => {
        setProviderMTN(res.data.data);
      });
  }, []);
  const validate = () => {
    let isValid = true;
    let temp = { ...formValues };

    // Example validation, customize according to your needs
    if (!temp.first_name.value) {
      temp.first_name.error = "الحقل مطلوب";
      isValid = false;
    }

    if (!temp.last_name.value) {
      temp.last_name.error = "الحقل مطلوب";
      isValid = false;
    } 
    if (!temp.father_name.value) {
      temp.father_name.error = "الحقل مطلوب";
      isValid = false;
    } 
    if (!temp.mother_name.value) {
      temp.mother_name.error = "الحقل مطلوب";
      isValid = false;
    } 

    if (!temp.mobile_number.value) {
      temp.mobile_number.error = "الحقل مطلوب";
      isValid = false;
    } 
    if (!temp.id_number.value) {
      temp.id_number.error = "الحقل مطلوب";
      isValid = false;
    } else if (temp.id_number.value.length !== 11) {
      temp.id_number.error = "يجب أن يكون رقم الوطني 11 رقمًا";
      isValid = false;
    } 
    if (temp.personal_photo.error !== "") {
      isValid = false;
    }
    if (temp.id_photo1.error && temp.id_photo1.error !== "") {
      isValid = false;
    }
    if (temp.id_photo2.error && temp.id_photo2.error !== "") {
      isValid = false;
    }
    // Add more validation checks for other fields

    setFormValues({
      ...temp,
    });
    return isValid;
  };
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupOpen2, setPopupOpen2] = useState(false);
  const [popupOpen3, setPopupOpen3] = useState(false);
const pastpath =localStorage.getItem('lastPath');
  // const handleImageClick = (file) => {
  //   console.log('File received in handleImageClick: ' + file);
  //   if (file && file instanceof Blob) {  // Check if it's a file or blob
  //     try {
  //       const url = URL.createObjectURL(file);
  //       setSelectedImage(url);
  //       setPopupOpen(true);
  //     } catch (error) {
  //       console.error("Error creating object URL: ", error);
  //     }
  //   } else {
  //     console.error("Attempted to create URL from invalid file: ", file);
  //   }
  // };
  const handleImageClick = (file) => {


    // Check if 'file' is an array and has at least one element
    if (Array.isArray(file) && file.length > 0) {
        const url = file[0]; // Assuming it's always the first element
        setSelectedImage(url);
        setPopupOpen(true);
    } else {
        console.error("Invalid or empty array:", file);
    }
};
const handleImageClick2 = (url) => {

  // Since the URL is a string and directly usable, we can use it as is.
  if (url && typeof url === 'string') {
      setSelectedImage(url); // This may be redundant if it's already set as selectedImage.
      setPopupOpen(true);
  } else {
      console.error("Invalid URL or empty string:", url);
  }
};
  const handleImageClick3 = (file) => {
 

    // Check if 'file' is an array and has at least one element
    if (Array.isArray(file) && file.length > 0) {
        const url = file[0]; // Assuming it's always the first element
        setSelectedImage2(url);
        setPopupOpen2(true);
    } else {
        console.error("Invalid or empty array:", file);
    }
};
const handleImageClick4 = (url) => {
  

  // Since the URL is a string and directly usable, we can use it as is.
  if (url && typeof url === 'string') {
      setSelectedImage2(url); // This may be redundant if it's already set as selectedImage.
      setPopupOpen2(true);
  } else {
      console.error("Invalid URL or empty string:", url);
  }
};
  const handleImageClick5 = (file) => {


    // Check if 'file' is an array and has at least one element
    if (Array.isArray(file) && file.length > 0) {
        const url = file[0]; // Assuming it's always the first element
        setSelectedImage3(url);
        setPopupOpen3(true);
    } else {
        console.error("Invalid or empty array:", file);
    }
};
const handleImageClick6 = (url) => {


  // Since the URL is a string and directly usable, we can use it as is.
  if (url && typeof url === 'string') {
      setSelectedImage3(url); // This may be redundant if it's already set as selectedImage.
      setPopupOpen3(true);
  } else {
      console.error("Invalid URL or empty string:", url);
  }
};

  const handleClose = () => {
    setPopupOpen(false);
    setPopupOpen2(false);
    setPopupOpen3(false);
  };

  const imageRef = useRef();
  const onChange = useCallback(
    (e) => {
      if (e !== null && e[0]) {
        // Get the Blob object from e.originFileObj
        const blob = e[0];

        // Create a new File object from the Blob
        const file = new File([blob], blob.name, {
          type: blob.type,
          size: blob.size,
        });

        setSelectedImages({
          ...selectedImages,
          personalImage: file,
        });
        setPersonImage1(file);
      } else {
        // Handle image removal here, for example, by setting personalImage to null or an empty value.
        setSelectedImages({
          ...selectedImages,
          personalImage: null, // or you can set it to an empty value as needed
        });
      }
    },
    [] // Add your dependencies here if needed
  );
  useEffect(() => {
    setTimeout(() => {
      if (formValues.zone_id.value) {
        setIsLoading(true);
      }
    }, 500);
  }, [formValues.zone_id.value]);
  // useEffect(() => {
  //   axios
  //     .get(`${BaseUrl}/api/staff/${id}`, {
  //       withCredentials: true,
  //     })
  //     .then((res) => {
   
  //     });
  // }, []);
  const handelcity = (e) => {
    e.persist();
    setcity_id2({ ...city_id2, [e.target.name]: e.target.value });
    setFormValues({
      ...formValues,
      [e.target.name]: {
        value: e.target.value,
        error: "",
      },
    });
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();

    axios
      .get(`${BaseUrl}/api/country/${city_id}/city/${city_id2.city_id}/zones`, {
        withCredentials: true,
      })
      .then((resZone) => {
        setZone(resZone.data.data);
      });
  };

  function cancleUpdate() {
    {
      location.pathname == `/update-staff/${id}/${cityid}/${zoneid}`
        ? navigate("/staff")
        : navigate("/staffReqest");
    }
  }
  const handleChange = (event) => {
    event.persist();
    // setFormValues({ ...formValues, [event.target.name]: event.target.value });
    setFormValues({
      ...formValues,
      [event.target.name]: {
        value: event.target.value,
        error: "",
      },
    });
  };
  const handleChangestaff = (event) => {
    event.persist();
    setFormValues({ ...formValues, staff_type: { value: event.target.value } });
    setFormValues({
      ...formValues,
      staff_type: {
        value: event.target.value,
        error: "",
      },
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      setLoading(true);
     
      const config = {
        headers: {
          Accept: "application/json",
          Authorization: null,
          sameSite: "strict",
        },
      };

      var fieldType;
      if (event.target.staff_type.value == admin) {
        setAdminArabic(adminArabic);
        fieldType = adminArabic;
        setFormValues({ ...formValues, staff_type: adminArabic });
      } else {
        setAdminArabic(event.target.staff_type.value);
        fieldType = Staffoption;
        setFormValues({ ...formValues, staff_type: Staffoption });
      }
      const formData = new FormData();
      formData.append("personal_photo", selectedImage1);
      formData.append("id_photo1", selectedImage22);
      formData.append("id_photo2", selectedImage33);
      formData.append("first_name", formValues.first_name.value);
      formData.append("last_name", formValues.last_name.value);
      formData.append("father_name", formValues.father_name.value);
      formData.append("mother_name", formValues.mother_name.value);
      formData.append("mobile_number", formValues.mobile_number.value);
      formData.append("id_number", formValues.id_number.value);
      formData.append("address", formValues.address.value);
      formData.append("staff_type", formValues.staff_type.value);
      formData.append("city_id", formValues.city_id.value);
      formData.append("zone_id", formValues.zone_id.value);
      formData.append("longitude", formValues.longitude.value);
      formData.append("latitude", formValues.latitude.value);
      formData.append("active", 1);

      axios
        .post(`${BaseUrl}/api/updateStaff/${id}`, formData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.message, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              if(pastpath === '/staff'){

                navigate("/staff");
              }else{
                navigate("/staffReqest");

              }
            });
            const dataMTN = {
              staff_id: id,
              distributor_id: providerMTN1,
            };

            axios.post(`${BaseUrl}/api/assignDistributorCodeToStaff`, dataMTN, {
              withCredentials: true,
            });

            const dataSyriatel = {
              staff_id: id,
              provider_id: providerSyriatel1,
            };

            axios.post(`${BaseUrl}/api/assignGsmToStaff`, dataSyriatel, {
              withCredentials: true,
            });
            setLoading(false);
          } else {
            sweetalert("error");
          }
        }) .catch((err) => {
          if (err.response && err.response.status === 500) {
            sweetalert(err.response.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        });
    }
  };

  const handelMTN = (e) => {
    setproviderMTN1(e.target.value);
  };
  const handelSyriatel = (e) => {
    setproviderSyriatel1(e.target.value);
  };

  return (
    <div className="main-div">
      {location.pathname == `/update-staff/${id}/${cityid}/${zoneid}` ? (
        <h3 className="titlepage">تعديل مستخدم</h3>
      ) : (
        <h3 className="titlepage">تعديل طلب انضمام</h3>
      )}

      <form
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >
        {isLoading ? (
          <>
            <Grid container maxWidth="sm" spacing={4}>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخال الاسم الأول"
                  className="form-control"
                  label="اسم المستخدم"
                  name="first_name"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.first_name.value}
                  onChange={handleChange}
                  error={!!formValues.first_name.error}
                  helperText={formValues.first_name.error}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخالا الاسم الاخير"
                  className="form-control"
                  label="الكنية"
                  name="last_name"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.last_name.value}
                  onChange={handleChange}
                  error={!!formValues.last_name.error}
                  helperText={formValues.last_name.error}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخال اسم الأب"
                  className="form-control"
                  label="اسم الأب"
                  name="father_name"
                  variant="outlined"
                  fullWidth
                  value={formValues.father_name.value}
                  onChange={handleChange}
                  error={!!formValues.father_name.error}
                  helperText={formValues.father_name.error}
                  type="text"
                />
                {formValues.father_name.error}
              </Grid>
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال اسم الأم"
                  className="form-control"
                  label="اسم الأم"
                  name="mother_name"
                  variant="outlined"
                  fullWidth
                  value={formValues.mother_name.value}
                  error={!!formValues.mother_name.error}
                  helperText={formValues.mother_name.error}
                  onChange={handleChange}
                  type="text"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="select">
                  {" "}
                  <select
                    selected
                    name="staff_type"
                    class="select-text"
                    value={formValues.staff_type.value}
                    onChange={handleChangestaff}
                    error={!!formValues.staff_type.error}
                    helperText={formValues.staff_type.error}
                  >
                    <option selected disabled>
                      {adminArabic}
                    </option>
                    {staff.map((opts, i) => (
                      <option key={opts.id} value={opts.en_name}>
                        {opts.ar_name}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                  <label class="select-label"> النوع </label>
                </div>
              </Grid>
              
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال رقم الموبايل"
                  className="form-control"
                  label="رقم الموبايل"
                  name="mobile_number"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.mobile_number.value}
                  error={!!formValues.mobile_number.error}
                  helperText={formValues.mobile_number.error}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال الرقم الوطني"
                  className="form-control"
                  label="الرقم الوطني"
                  name="id_number"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.id_number.value}
                  error={!!formValues.id_number.error}
                  helperText={formValues.id_number.error}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="خطوط العرض"
                  className="form-control"
                  label="خطوط العرض"
                  name="latitude"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.latitude.value}
                  onChange={handleChange}
                  error={!!formValues.latitude.error}
                  helperText={formValues.latitude.error}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="خطوط الطول"
                  className="form-control"
                  label="خطوط الطول"
                  name="longitude"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.longitude.value}
                  onChange={handleChange}
                  error={!!formValues.longitude.error}
                  helperText={formValues.longitude.error}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال العنوان التفصيلي"
                  className="form-control"
                  label="العنوان التفصيلي"
                  name="address"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.address.value}
                  error={!!formValues.address.error}
                  helperText={formValues.address.error}
                  onChange={handleChange}
                />
              </Grid>

              {/* <Grid item md={6} xs={12}>

                <div class="select">
                  {" "}
                  <select
                    onChange={handelcity}
                    name="city_id"
                    class="select-text"
                  >
                    {city.map((opts, i) => {
                      if (cityid == opts.id) {
                        return (
                          <option
                            key={i}
                            onClick={handleSubmit1}
                            value={opts.id}
                          >
                            {opts.name_ar}
                          </option>
                        );
                      }
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="select">
                  <select selected name="zone_id" class="select-text">
                    {zone.map((opts, i) => {
                      if (zoneid == opts.id) {
                        return (
                          <option key={i} value={opts.id}>
                            {opts.name}
                          </option>
                        );
                      }
                    })}
                  </select>
                </div>
              </Grid> */}
              <Grid item md={6} xs={12}>
                <div class="select">
                  {" "}
                  <select
                    onChange={handelcity}
                    name="city_id"
                    class="select-text"
                    value={formValues.city_id.value}
                  >
                    {city.map((opts, i) => {
                      return (
                        <option key={i} onClick={handleSubmit1} value={opts.id}>
                          {opts.name_ar}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="select">
                  <select
                    selected
                    name="zone_id"
                    class="select-text"
                    onChange={handleChange}
                    value={formValues.zone_id.value}
                  >
                    {zone.map((opts, i) => {
                      return (
                        <option key={i} value={opts.id}>
                          {opts.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <label class="select-label1"> نقطة بيع Syriatel </label>

                <div class="select">
                  <select
                    selected
                    value={providerSyriatel1}
                    class="select-text"
                    name="provider_id"
                    onChange={(e) => handelSyriatel(e)}
                  >
                    <option selected disabled className="title-option">
                      نقطة بيع Syriatel
                    </option>
                    {providerSyriatel.map((opts, i) => (
                      <option key={opts.id} value={opts.id}>
                      {opts.gsm} - {opts.OwnerProvider}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                  <label class="select-label"> نوع التحويل</label>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <label className="select-label1">نقطة بيع MTN</label>
                <div class="select">
                  <select
                    selected
                    value={providerMTN1}
                    class="select-text"
                    name="distributor_id"
                    onChange={(e) => handelMTN(e)}
                  >
                    <option selected disabled className="title-option">
                      نقطة بيع MTN
                    </option>
                    {providerMTN.map((opts, i) => (
                      <option key={opts.id} value={opts.id}>
                       {opts.DealerCode} -{opts.OwnerDistributor}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                  <label class="select-label"> نوع التحويل</label>
                </div>
              </Grid>
              <Grid item lg={12} md={12} xs={12}>
                <hr className="div-line-image"></hr>
              </Grid>
              
              {/* <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الشخصية
                </label>
                <ImageInput
                  onChange={(e) => onChange(e)}
                  value={selectedImages.personalImage} // Pass initial image data here
                  ref={imageRef}
                  title="صورة الشخصية"
                  name="personal_photo"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الهوية الأمامية
                </label>
                <ImageInput
                  // onChange={(e) =>
                  //   setSelectedImages({
                  //     ...selectedImages,
                  //     frontIdImage: e.target.files[0],
                  //   })
                  // }
                  ref={imageRef}
                  value={selectedImages.frontIdImage} // Pass initial image data here
                  title="صورة الهوية الأمامية"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الهوية الخلفية
                </label>
                <ImageInput
                  // onChange={(e) =>
                  //   setSelectedImages({ ...selectedImages, backIdImage: e.target.files[0]})
                  // }
                  ref={imageRef}
                  title="صورة الهوية الخلفية"
                  value={selectedImages.backIdImage} // Pass initial image data here
                />
              </Grid> */}
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
              >
                {/* <Grid md={4} xs={4}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      
                      marginBottom: selectedImage !== '' ? '20px' :'0'
                    }}
                  >
                    {selectedImage ? (
                      <div className="box_img_update" style={{marginTop:'-20px'}}>
                                    
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt="Thumb"
                        />
                      </div>
                    ) : (
                      <div className="box_img_update">
                        <img src={img} />
                      </div>
                    )}
                         
                    <div style={{ color: "red", marginTop: "10px",height: "20px" }}>
                      {formValues.personal_photo.error &&
                        formValues.personal_photo.error}
                    </div>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <TextField
                      placeholder="الرجاءإدخال  لوغو نقطة البيع"
                      className="form-control"
                      label="لوغو نقطة البيع"
                      name="personal_photo"
                      fullWidth
                      required
                      type="file"
                      onChange={imageChange}
                  
                    />
                  </Grid>
                </Grid> */}

                      {/* Other Grid items */}
                <Grid md={4} xs={4}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      
                      // marginBottom: selectedImage !== '' ? '20px' :'0'
                    }}
                  >
          <div className="box_img_update">
            {selectedImage ? (
              <div className="box_img_update"  onClick={() => selectedImage && handleImageClick2(selectedImage)} >
                                              
                                  <img
                                    src={selectedImage}
                                    alt="Thumb"
                                  />
                                </div>
            ) : (
              <div className="box_img_update"  onClick={() => img && handleImageClick(img)} >
              <img src={img} alt="Default" />
                                </div>
            )}
          </div>
          <div style={{ color: "red", marginTop: "30px",height: "20px" }}>
                      {formValues.personal_photo.error &&
                        formValues.personal_photo.error}
                    </div>
          </Grid>
          <Grid item md={12} xs={12}>

            <TextField
              placeholder="الرجاء إدخال لوغو نقطة البيع"
              className="form-control"
              label="لوغو نقطة البيع"
              name="personal_photo"
              fullWidth
              required
              type="file"
            
              onChange={imageChange}
            />
            </Grid>
          <ImagePopup open={popupOpen} handleClose={handleClose} imgSrc={selectedImage} />
            </Grid>
                    <Grid md={4} xs={4}>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                          // marginBottom: selectedImage2 !== '' ? '20px' :'0'
                        }}
                      >
                        {/* {selectedImage2 ? (
                          <div className="box_img_update" style={{marginTop:'-20px'}}>
                                        
                            <img
                              src={URL.createObjectURL(selectedImage2)}
                              alt="Thumb"
                            />
                          </div>
                        ) : (
                          <div className="box_img_update">
                            <img src={img1} alt="image_id_1" />
                          </div>
                        )} */}

                        <div className="box_img_update">
                        {selectedImage2 ? (
                          <div className="box_img_update"  onClick={() => selectedImage2 && handleImageClick4(selectedImage2)} >
                                                          
                                              <img
                                                src={selectedImage2}
                                                alt="Thumb"
                                              />
                                            </div>
                        ) : (
                          <div className="box_img_update"  onClick={() => img1 && handleImageClick3(img1)} >
                          <img src={img1} alt="Default" />
                                            </div>
                        )}
                      </div>
                        <div style={{ color: "red", marginTop: "30px",height: "1px" }}>
                          {formValues.id_photo1.error && formValues.id_photo1.error}
                        </div>
                                  
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <TextField
                          placeholder="الرجاءإدخال صورة الهوية  صورة الخلفية"
                          className="form-control"
                          label="صورة الهوية الخلفية"
                          name="id_photo1"
                          fullWidth
                          required
                          type="file"
                          onChange={imageChange2}
                          
                        />
                      </Grid>
                      <ImagePopup open={popupOpen2} handleClose={handleClose} imgSrc={selectedImage2} />

                    </Grid>
                    <Grid md={4} xs={4}>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                          // marginBottom: selectedImage3 !== '' ? '20px' :'0'
                        }}
                      >
    
          {/* Repeat for other images */}
          
          {/* Popup Modal */}
                        {/* {selectedImage3 ? (
                          <div className="box_img_update" style={{marginTop:'-20px'}}>
                                        
                            <img
                              src={URL.createObjectURL(selectedImage3)}
                              alt="Thumb"
                            />
                          </div>
                        ) : (
                          <div className="box_img_update">
                            <img src={img2} alt="image_id_2" />
                          </div>
                        )} */}
                        <div className="box_img_update">
                        {selectedImage3 ? (
                          <div className="box_img_update"  onClick={() => selectedImage3 && handleImageClick6(selectedImage3)} >
                                                          
                                              <img
                                                src={selectedImage3}
                                                alt="Thumb"
                                              />
                                            </div>
                        ) : (
                          <div className="box_img_update"  onClick={() => img2 && handleImageClick5(img2)} >
                          <img src={img2} alt="Default" />
                                            </div>
                        )}
                      </div>
                            
                        <div style={{ color: "red", marginTop: "10px", height:'1px' }}>
                          {formValues.id_photo2.error && formValues.id_photo2.error}
                        </div>
                        </Grid>     
                      
                      <Grid item md={12} xs={12}>
                        <TextField
                          placeholder="الرجاءإدخال صورة الهوية  صورة الأمامية"
                          className="form-control"
                          label="صورة الهوية الأمامية"
                          name="id_photo2"
                          fullWidth
                          required
                          type="file"
                          onChange={imageChange3}
                        />
                      </Grid>
                      <ImagePopup open={popupOpen3} handleClose={handleClose} imgSrc={selectedImage3} />

                    </Grid>
              </Grid>
            </Grid>

            <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
              {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                  <Controls.Button
                    type="submit"
                    text="إلغاء"
                    onClick={cancleUpdate}
                    variant="contained"
                    className="btn-submit1"
                    color="secondary"
                  ></Controls.Button>
                </>
              ) : (
                <>
                  <Controls.Button
                    // disabled= {(formValues.id_photo1.error != '' ||formValues.id_photo2.error != '' || formValues.personal_photo.error != '') ? true :false}
                    type="submit"
                    text="تعديل"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                  <Controls.Button
                    type="submit"
                    text="إلغاء"
                    onClick={cancleUpdate}
                    variant="contained"
                    className="btn-submit1"
                    color="secondary"
                  ></Controls.Button>
                </>
              )}
            </Grid>
          </>
        ) : (
          <img src={`${homepage}/loading.svg`} alt="load" className="load" />
        )}
      </form>
    </div>
  );
}
